import { Component, Input } from '@angular/core';
import { DynamicFormElement } from '../../../../models';

@Component({
  selector: 'ellipse-dynamic-form-fields-expansion-container',
  templateUrl: './dynamic-form-fields-expansion-container.component.html',
  styleUrls: ['./dynamic-form-fields-expansion-container.component.scss']
})
export class DynamicFormFieldsExpansionContainerComponent {

  @Input() dynamicFormElement!: DynamicFormElement;

}
